export default __webpack_public_path__ + "static/media/volunteer-experience.40e03425.png";